// extracted by mini-css-extract-plugin
module.exports = {"SocialButton":"SocialButton_SocialButton___0upw"};